import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { en, es, ptBR } from './i18nLocales.ts';
// import en from './locales/en.json';
// import es from './locales/es.json';
// import ptBR from './locales/pt-BR.json';

i18n.use(LanguageDetector).init({
  resources: {
    en: {
      translation: en,
    },
    'pt-BR': {
      translation: ptBR,
    },
    es: {
      translation: es,
    },
  },
  fallbackLng: 'pt-BR',
  debug: false,
  nsSeparator: false,
  keySeparator: false,

  interpolation: {
    escapeValue: false, // not needed for react!!
    formatSeparator: ',',
  },

  react: {
    useSuspense: true,
  },
});

export default i18n;
